export enum PaymentMethodTypeEnum {
  CREDIT_DEBIT_CARD = 'CARD',
  GOOGLE_PAY = 'GOOGLE_PAY',
  APPLE_PAY = 'APPLE_PAY',
  GIFT_CARD = 'GIFT_CARD',
  CASH = 'CASH',
  STRIPE = 'STRIPE'
}
